import countries from './countries.json';

const countriesArray = Object.entries(countries).map(([code, name]) => ({
  code,
  name,
}));

export default angular
  .module('doxy.common.services.countryService', [])
  .service('countryService', function () {
    return {
      getCountries() {
        return countries;
      },
      getCountriesArray() {
        return countriesArray;
      },
    };
  }).name;
